import {BaseBreadcrumb} from "@/components";
import UserProfile from "@/components/UserProfile";

const CRUMBS = [{label: "Perfil"}];

const ProfilePage = () => (
  <section className="mx-auto flex w-full max-w-md flex-col gap-4 px-4 py-8">
    <BaseBreadcrumb items={CRUMBS} />
    <UserProfile />
  </section>
);

export default ProfilePage;
